const STEP = 5;
export const BUY_MAX_SHARES = 10000;
export const SELL_MAX_SHARES = Number.MAX_SAFE_INTEGER; // 不做限制
